module.exports = __webpack_public_path__ + "static/media/search_prototype_results_shaded.3a33d00a.png";